
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import {Prop} from 'vue-property-decorator';

    @Component({})
   export default class BackgroundImage extends Vue {
        @Prop({})
        src!: string;

        @Prop({default: 'transparent'})
        color!: string;

        get style() {
            const styles = [];
            styles.push(`background-color: ${this.color}`);
            if (this.src) {
                styles.push(`background-image: url(${this.src})`);
            }
            return styles.join(';')
        }
    }

